import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from 'react-icons/fa';
import  "./Slider.css";

const NotFound = () => {
  const navigate = useNavigate();
  const prevSlide = () => {
     navigate("/")
  }
  return (
    <>
      <FaArrowLeft className="arrow_add" onClick={prevSlide} />
      <div className="d-flex justify-content-center align-items-center">
        <h1>Looks like you are lost</h1>
      </div>
    </>
  );
};
export default NotFound;
